import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authApi } from "./api";
import { qk } from "../../lib/queryKeys";

export const useRemoveSession = () => {
  const qc = useQueryClient();

  return () => {
    // Remove all queries except the session query so observers don't detach
    const meKeyStr = JSON.stringify(qk.me());
    qc.removeQueries({
      predicate: (query) => JSON.stringify(query.queryKey) !== meKeyStr,
    });

    // Set session as unauthenticated
    qc.setQueryData(qk.me(), {
      authenticated: false,
      user: null,
      needs_new_password: false,
    });
  };
};

export const useLogin = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useChangePassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.changePassword,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useLogout = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: async () => {
      // Remove all queries except the session query so observers don't detach
      const meKeyStr = JSON.stringify(qk.me());
      qc.removeQueries({
        predicate: (query) => JSON.stringify(query.queryKey) !== meKeyStr,
      });

      // Set session as unauthenticated
      qc.setQueryData(qk.me(), {
        authenticated: false,
        user: null,
        needs_new_password: false,
      });
    },
    onError: async (error) => {
      console.error("Logout mutation error:", error);
      // Remove all queries except the session query so observers don't detach
      const meKeyStr = JSON.stringify(qk.me());
      qc.removeQueries({
        predicate: (query) => JSON.stringify(query.queryKey) !== meKeyStr,
      });

      // Still remove session even if logout fails
      qc.setQueryData(qk.me(), {
        authenticated: false,
        user: null,
        needs_new_password: false,
      });
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: authApi.forgotPassword,
  });
};

export const useConfirmForgotPassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.confirmForgotPassword,
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.me() }),
  });
};
